import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsCustomTimeScaleRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-custom-time-scale',
	path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId',
};
